/* unplugin-vue-components disabled */import { render } from "./DefaultView.vue?vue&type=template&id=04c8cd02"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__